import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Card, Button, Spinner, Table } from "react-bootstrap";

const RenewalView = () => {
  const { controlNo } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetchPayload();
  }, []);

  const fetchPayload = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.get(
        `${apiUrl}fetch-renewal-payload/${controlNo}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setData(response.data?.data);
    } catch (error) {
      console.error("Error fetching renewal payload:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderField = (label, value) => (
    <tr>
      <th style={{ width: "30%" }}>{label}</th>
      <td>{value !== null && value !== undefined ? value.toString() : "—"}</td>
    </tr>
  );

  const renderAddress = (prefix, label) => (
    <>
      <h5 className="mt-4">{label}</h5>
      <Table bordered size="sm" className="renewal-table">
        <tbody>
          {renderField("Address", data[`${prefix}_address`])}
          {renderField("City", data[`${prefix}_city`])}
          {renderField("State", data[`${prefix}_state`])}
          {renderField("ZIP", data[`${prefix}_zip`])}
        </tbody>
      </Table>
    </>
  );

  {
    /* Added some padding and max-width for better layout */
  }
  <style>
    {`
  .renewal-view-container {
    max-width: 900px;
    margin: 0 auto;
    padding: 20px;
  }
  .renewal-section {
    margin-bottom: 30px;
  }
  .renewal-section h5 {
    border-bottom: 2px solid #007bff;
    padding-bottom: 5px;
    margin-bottom: 15px;
    color: #007bff;
  }
  .renewal-table th {
    background-color: #f8f9fa;
    width: 35%;
  }
  .renewal-table td {
    word-break: break-word;
  }
  .notes-list {
    max-height: 200px;
    overflow-y: auto;
  }
`}
  </style>;
  return (
    <div className="container mt-4 renewal-view-container">
      <Button
        variant="secondary"
        className="mb-3"
        onClick={() => navigate("/renewals-logs")}
      >
        ← Back
      </Button>

      {loading ? (
        <div className="text-center mt-5">
          <Spinner animation="border" role="status" />
        </div>
      ) : data ? (
        <Card className="shadow-sm mb-4">
          <Card.Header>
            <h4>Renewal Details – {data?.InsuredName || "N/A"}</h4>
          </Card.Header>
          <Card.Body>
            <h5 className="mb-3">General Info</h5>
            <Table bordered size="sm">
              <tbody>
                {renderField("Control Number", data.PreviousControlNumber)}
                {renderField("Policy Number", data.RenewalofPolicyNumber)}
                {renderField("Quote GUID", data.RenewalofQuoteGUID)}
                {renderField("Type", data.type)}
                {renderField("Version", data.version)}
                {renderField("Quote or Inquiry", data.QuoteorInquiry)}
                {renderField("Need by Date", data.NeedbyDate)}
                {renderField("Effective Date", data.PolicyEffectiveDate)}
                {renderField("Expiring Date", data.Policyexpiringdate)}
                {renderField("Expiring Carrier", data.ExpiringCarrier)}
                {renderField("Policy Type", data.policyType)}
                {renderField("Insuring Agreement", data.InsuringAgreement)}
                {renderField("Construction Type", data.ConstructionType)}
                {renderField("Year Built", data.YearBuilt)}
              </tbody>
            </Table>

            <h5>Limits & Values</h5>
            <Table bordered size="sm">
              <tbody>
                {renderField("Target Premium", `$${data.TargetPremium}`)}
                {renderField("Total Insured Value (TIV)", `$${data.TIV}`)}
                {renderField("Building Limit", `$${data.BuildingLimit}`)}
                {renderField(
                  "BPP Limit",
                  `$${data.BusinessPersonalPropertyLimit}`
                )}
                {renderField("AOP Deductible", `$${data.AOPDeductible}`)}
                {renderField("GL Deductible", data.GLDeductible)}
                {renderField("GL Limit", data.GL)}
                {renderField("Sprinklers", data.Sprinklers)}
                {renderField(
                  "Stories (including subterranean)",
                  data.NumberofStoriessubterraneanstr
                )}
                {renderField("Completed Units", data.NumberofCompletedUnits)}
                {renderField("Number of Buildings", data.NumberofBuildings)}
                {renderField("Livable SqFt", data.LivableSquareFootage)}
                {renderField(
                  "Separate Structure SqFt",
                  data.SeparateStructureSquareFootage
                )}
              </tbody>
            </Table>

            <h5>Optional Coverages & Deductions</h5>
            <Table bordered size="sm">
              <tbody>
                {renderField("Qualifying Questions", data.QualifyingQuestions)}
                {renderField(
                  "Garage Parking Liability",
                  data.GarageParkingLiability ? "Yes" : "No"
                )}
                {renderField(
                  "Hired/Non-Owned Auto Liability",
                  data.HiredNonOwnedAutoLiability ? "Yes" : "No"
                )}
                {renderField(
                  "Equipment Breakdown",
                  data.EquipmentBreakdown ? "Yes" : "No"
                )}
                {renderField(
                  "Equipment Breakdown Limit",
                  data.EquipmentBreakdownLimit
                )}
                {renderField("Business Income Limit", data.BusinessIncomeLimit)}
                {renderField("Fire Legal Liability", data.FireLegalLiability)}
                {renderField(
                  "Water/Sewer/Sprinkler Deductible",
                  data.WaterSewerSprinklerDeductible
                )}
                {renderField(
                  "Ice Damming Deductible",
                  data.IceDammingDeductible
                )}
                {renderField("Wind/Hail Deductible", data.WindHailDeductible)}
                {renderField("EQ S/L Deductible", data.EQSLDeductible)}
                {renderField("EQ S/L Limit", data.EQSLLimit)}
                {renderField(
                  "Earthquake Coverage (OR/WA)",
                  data.EarthquakeLimitavailableinORan
                )}
              </tbody>
            </Table>

            <h5>Agent Info</h5>
            <Table bordered size="sm">
              <tbody>
                {renderField("Agent ID", data.agent?.id)}
                {renderField("Agent Display", data.agent?.display)}
                {renderField("Agent Type", data.agent?.type)}
                {renderField("Unique ID", data.agent?._unique_id)}
              </tbody>
            </Table>

            {renderAddress(
              "address_a9cc85306bf311eb993bf748bf3010c5",
              "Mailing Address"
            )}
            {renderAddress(
              "address_3b8615006bf311eb993bf748bf3010c5",
              "Risk Address"
            )}

            <h5 className="mt-4">Claims & Underwriting</h5>
            <Table bordered size="sm">
              <tbody>
                {renderField(
                  "Total Number of Claims",
                  data.TotalNumberofClaims
                )}
                <tr>
                  <th colSpan="2">
                    <h6 className="mb-2">Loss Run Details</h6>
                    {(() => {
                      let lossData = [];
                      try {
                        lossData = Array.isArray(data.Lossrun)
                          ? data.Lossrun
                          : JSON.parse(data.Lossrun);
                      } catch (err) {
                        console.error("Lossrun parse error:", err);
                      }

                      return lossData.length > 0 ? (
                        <Table bordered size="sm" className="mt-2">
                          <thead>
                            <tr>
                              <th>Date of Claim</th>
                              <th>Loss Type</th>
                              <th>Claim Type</th>
                              <th>Status</th>
                              <th>Cost</th>
                              <th>Carrier</th>
                              <th>Premium</th>
                              <th>TIV/Payroll/Vehicle</th>
                              <th>Details & Preventive</th>
                              <th>Date Reported</th>
                              <th>Expense Paid</th>
                              <th>Total Reserve</th>
                            </tr>
                          </thead>
                          <tbody>
                            {lossData.map((item, idx) => (
                              <tr key={idx}>
                                <td>{item.Loss_DateofClaim || "—"}</td>
                                <td>{item.Loss_LossType || "—"}</td>
                                <td>{item.Loss_ClaimType || "—"}</td>
                                <td>{item.Loss_ClaimStatus || "—"}</td>
                                <td>
                                  {item.Loss_Claimscost
                                    ? `$${item.Loss_Claimscost}`
                                    : "—"}
                                </td>
                                <td>{item.Loss_Carrier || "—"}</td>
                                <td>{item.Loss_Premium || "—"}</td>
                                <td>
                                  {item.Loss_TIVAuditedPayrollsTotalVehicle ||
                                    "—"}
                                </td>
                                <td>{item.Loss_DetailsandPreventive || "—"}</td>
                                <td>{item.ClaimsDateReported || "—"}</td>
                                <td>
                                  {item.ExpensePaid
                                    ? `$${item.ExpensePaid}`
                                    : "—"}
                                </td>
                                <td>
                                  {item.TotalReserve
                                    ? `$${item.TotalReserve}`
                                    : "—"}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      ) : (
                        <p className="text-muted">
                          No loss run data available.
                        </p>
                      );
                    })()}
                  </th>
                </tr>
              </tbody>
            </Table>

            <h5 className="mt-4">Additional Metadata</h5>
            <Table bordered size="sm">
              <tbody>
                {renderField("Last Updated By", data.lastUpdatedBy)}
                {renderField("Is Active", data.isActive ? "Yes" : "No")}
                {renderField(
                  "Created At",
                  data.createdAt
                    ? new Date(data.createdAt).toLocaleString()
                    : "—"
                )}
                {renderField(
                  "Updated At",
                  data.updatedAt
                    ? new Date(data.updatedAt).toLocaleString()
                    : "—"
                )}
              </tbody>
            </Table>

            <h5 className="mt-4">Notes</h5>
            {data.notes && data.notes.length > 0 ? (
              <ul className="list-group list-group-flush">
                {data.notes.map((note, idx) => (
                  <li key={idx} className="list-group-item">
                    <strong>{new Date(note.date).toLocaleDateString()}:</strong>{" "}
                    {note.note}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No notes found.</p>
            )}
          </Card.Body>
        </Card>
      ) : (
        <div>No data found for Control No: {controlNo}</div>
      )}
    </div>
  );
};

export default RenewalView;
